var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContractStatusEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.5714 6H41.2092C42.2733 6 43.3029 6.37705 44.1153 7.06422L58.4061 19.1518C59.417 20.0068 60 21.2636 60 22.5876V60.25C60 65.6216 59.9387 66 54.4286 66H17.5714C12.0613 66 12 65.6216 12 60.25V11.75C12 6.37837 12.0613 6 17.5714 6Z",
    fill: "#506EFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 33H21C19.3431 33 18 34.3431 18 36C18 37.6569 19.3431 39 21 39H42C43.6569 39 45 37.6569 45 36C45 34.3431 43.6569 33 42 33Z",
    fill: "#506EFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45H21C19.3431 45 18 46.3431 18 48C18 49.6569 19.3431 51 21 51H30C31.6569 51 33 49.6569 33 48C33 46.3431 31.6569 45 30 45Z",
    fill: "#506EFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractStatusEmpty);
export default __webpack_public_path__ + "static/media/contractStatusEmpty.b417d742d92da21ea0dd0fa820aa7b47.svg";
export { ForwardRef as ReactComponent };